import { createFileRoute } from '@tanstack/react-router';
// applies the saved interface settings app-wide from start-up (the route tree evaluates this file eagerly)
import '@/features/settings/boot';
import { InterfaceSettingsPage } from '@/features/settings/InterfaceSettingsPage';

/** "Interfeys sozlamalari" (556:16647). */
export const Route = createFileRoute('/_authed/_app/settings/interface')({
  component: InterfaceSettingsPage,
});
